import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-3 row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "position-relative" }
const _hoisted_4 = { class: "mt-3 row" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "mt-3 row" }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { class: "mt-3 row" }
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = { class: "mt-3 row" }
const _hoisted_11 = { class: "col-6" }
const _hoisted_12 = { class: "col-6" }
const _hoisted_13 = { class: "mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CountrySelect = _resolveComponent("CountrySelect")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_CountrySelect, {
            list: _ctx.users,
            checked: _ctx.users,
            type: "user",
            width: "320px",
            class: "position-relative",
            placeholder: "Chose users",
            "on-change": _ctx.selectUsersHandler
          }, null, 8, ["list", "checked", "on-change"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_CountrySelect, {
          list: _ctx.countries,
          checked: _ctx.countries,
          type: "country",
          disabled: !!_ctx.checkedRegions.length,
          class: "position-relative",
          placeholder: "Chose countries",
          "on-change": _ctx.selectCountryHandler
        }, null, 8, ["list", "checked", "disabled", "on-change"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_CountrySelect, {
          list: _ctx.regions,
          checked: _ctx.regions,
          class: "position-relative",
          type: "region",
          disabled: !!_ctx.checkedCountries.length,
          placeholder: "Chose regions",
          "on-change": _ctx.selectRegionHandler
        }, null, 8, ["list", "checked", "disabled", "on-change"])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_CountrySelect, {
          list: _ctx.subregions,
          checked: _ctx.subregions,
          type: "subregions",
          class: "position-relative",
          disabled: !_ctx.subregions.length,
          placeholder: "Chose subregions",
          "on-change": _ctx.selectSubregionHandler
        }, null, 8, ["list", "checked", "disabled", "on-change"])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_CountrySelect, {
          list: _ctx.plans,
          checked: _ctx.plans,
          type: "plans",
          class: "position-relative",
          placeholder: "Chose plans",
          disabled: !_ctx.plans.length,
          "with-search": false,
          "on-change": _ctx.selectPlansHandler
        }, null, 8, ["list", "checked", "disabled", "on-change"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_CountrySelect, {
          list: _ctx.bundles,
          checked: _ctx.bundles,
          disabled: !_ctx.bundles.length,
          width: "320px",
          type: "budles",
          class: "position-relative",
          placeholder: "Chose bundles",
          "on-change": _ctx.selectBundlesHandler
        }, null, 8, ["list", "checked", "disabled", "on-change"])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_AppButton, {
        size: "xl",
        disabled: _ctx.buttonDisabled,
        type: "secondary",
        onClick: _ctx.submit
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.editData ? "Edit" : "Create") + " promo code ", 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ])
  ]))
}